import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import ArticleContent from '../../../../../components/articleContent';
import SelectShare from '../../../../../../components/selectShare';

class MainContent extends React.PureComponent {
    static propTypes = {
        shareInfo: PropTypes.object,
        content: PropTypes.object,
        pluginData: PropTypes.object,
        editorName: PropTypes.string,
        editorCode: PropTypes.string,
    };

    state = {
        isShow: false,
        style: {},
        shareInfo: this.props.shareInfo,
    };

    handleSelectTxt = event => {
        const { shareInfo } = this.props;
        let text = '';

        try {
            text = document.selection.createRange().text;
        } catch (err) {
            text = window.getSelection().toString();
        }

        // 兼容 IE
        const e = event || window.event;
        const scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;
        const scrollY = document.documentElement.scrollTop || document.body.scrollTop;
        const left = e.pageX || e.clientX + scrollX;
        const top = e.pageY || e.clientY + scrollY;

        if (text !== '') {
            shareInfo.title = text;

            this.setState({
                isShow: true,
                style: {
                    top,
                    left,
                },
                shareInfo,
            });
        } else {
            this.setState({
                isShow: false,
            });
        }
    };

    render() {
        const { isShow, style, shareInfo } = this.state;
        const { content, pluginData, editorName, editorCode } = this.props;

        return (
            <div className={styles.main_content}>
                {content.contentList ? (
                    <div>
                        <ArticleContent
                            content={content}
                            pluginData={pluginData}
                            handleSelectTxt={this.handleSelectTxt}
                        />
                        {editorName && editorName !== '' ? (
                            <p className={styles.author}>{`责编：${editorName} ${editorCode}`}</p>
                        ) : (
                            ''
                        )}
                    </div>
                ) : (
                    ''
                )}
                {isShow ? <SelectShare styleObj={style} shareInfo={shareInfo} /> : ''}
            </div>
        );
    }
}

export default errorBoundary(MainContent);
